<div class="container">
  <!-- <img
    [src]="secureImage"
    alt="QR code"
    onerror="this.onerror=null; this.src='assets/images/404.svg';"
  /> -->
  <qrcode [qrdata]="qrdata" [width]="256" [allowEmptyString]="true" [errorCorrectionLevel]="'M'">
  </qrcode>
  <p>
    Escanea el código QR - <br />
    Escaneie o código QR
  </p>
  <app-onboarding-footer
    [positionAbsolute]="true"
    [showButton]="false"
    [privacyPolicy]="false"
  ></app-onboarding-footer>
</div>
